export default __webpack_public_path__ + "static/media/listbg.cb28b6b0.png";